
    <div style="max-width: 35em">
      <app-organization-not-found-page *ngIf="appController.isVisible('OrganizationNotFoundPage')"></app-organization-not-found-page>
      <app-license-already-ordered-page *ngIf="appController.isVisible('LicenseAlreadyOrderedPage')"></app-license-already-ordered-page>
      <app-start-page *ngIf="appController.isVisible('StartPage')"></app-start-page>
      <app-contact-address-page *ngIf="appController.isVisible('ContactAddressPage')"></app-contact-address-page>
      <app-billing-address-page *ngIf="appController.isVisible('BillingAddressPage')"></app-billing-address-page>
      <app-license-page *ngIf="appController.isVisible('LicensePage')"></app-license-page>
      <app-agb-page *ngIf="appController.isVisible('AgbPage')"></app-agb-page>
      <app-review-page *ngIf="appController.isVisible('ReviewPage')"></app-review-page>
      <app-success-page *ngIf="appController.isVisible('SuccessPage')"></app-success-page>
      <app-user-error-page *ngIf="appController.isVisible('UserErrorPage')"></app-user-error-page>
      <app-server-error-page *ngIf="appController.isVisible('ServerErrorPage')"></app-server-error-page>
    </div>
  